import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { WorkspacePanel } from '@genieartinc/studio-ui'
import { LibraryContent } from './LibraryContent'
import type { CatalogModel } from '@/lib/api/models'
import type { LibrarySketch } from '@/lib/canvas/shader/library'

interface LibraryPanelProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  host?: HTMLElement | null
  onAddToCanvas?: (model: CatalogModel) => void
  onAddShaderToCanvas?: (sketch: LibrarySketch) => void
  onDragStart?: (kind?: 'shader') => void
  communityModels?: ReactNode
  libraryAssets?: Partial<Record<'local-models' | '3d-models' | 'materials' | 'hdris' | 'shapes', ReactNode>>
  initialTab?: string
}

export function LibraryPanel({ open, onOpenChange, host, ...content }: LibraryPanelProps) {
  if (!open) return null
  const panel = <WorkspacePanel title="Library" onClose={() => onOpenChange(false)} className="!w-full h-full flex-1"><LibraryContent {...content} /></WorkspacePanel>
  return host ? createPortal(panel, host) : <div className="absolute top-4 bottom-4 right-4 z-30 w-[728px] max-w-[calc(100%-32px)] pointer-events-auto">{panel}</div>
}
